import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";

import { makeStyles } from "@mui/styles";
import { Divider } from "antd-mobile";
import * as React from "react";
import { listLicense } from "../../utils";

export default function DialogAddOriginalDocs(props) {
  const { dispatch, state } = props;
  const classes = makeStyle();
  const { dialogAddOriginalDoc } = state;

  return (
    <Dialog
      open={dialogAddOriginalDoc?.open}
      keepMounted
      maxWidth={"xl"}
      className={classes.dialog}
    >
      <DialogTitle>
        <div className="header">
          <div>Bổ sung chứng từ gốc</div>
          <CloseIcon
            onClick={() => {
              dispatch({ type: "handleMdAddOriginalDoc", open: false });
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 20 }}>
        <div className="title">Chọn thông tin chứng từ gốc cần bổ sung </div>
        <div className="info">
          <Grid container>
            {listLicense.map((item) => (
              <Grid item xs={12} sm={6} className="check-box">
                <Checkbox
                  key={item?.typeId}
                  checked={
                    Array.isArray(dialogAddOriginalDoc?.elements) &&
                    dialogAddOriginalDoc.elements.some(
                      (el) => el?.typeId === item?.typeId
                    )
                  }
                  onChange={(e) =>
                    dispatch({
                      type: "checkedMdAddOriginalDoc",
                      item,
                      checked: e.target.checked,
                    })
                  }
                  //   icon={<BpIcon />}
                  //   checkedIcon={<BpCheckedIcon />}
                />
                <div style={{ fontSize: 14 }}> {item?.title}</div>
              </Grid>
            ))}
          </Grid>
        </div>
        <Divider />
        <div className="title">Thông tin người nhận chứng từ </div>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <div className="textInput">
              <div className="label">
                Họ và tên người nhận {<span className="iconRed">*</span>}
              </div>
              <TextField
                fullWidth
                size="small"
                className="capitalize"
                value={dialogAddOriginalDoc?.fullname || ""}
                onChange={(e) =>
                  dispatch({
                    type: "onChangeMdAddOriginalDoc",
                    name: "fullname",
                    value: e.target.value,
                  })
                }
                placeholder={"Nhập họ và tên"}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className="textInput">
              <div className="label">
                Số điện thoại {<span className="iconRed">*</span>}
              </div>
              <TextField
                fullWidth
                size="small"
                type="tel"
                value={dialogAddOriginalDoc?.phoneNumber || ""}
                onChange={(e) => {
                  if (
                    !"0123456789".includes(e?.nativeEvent?.data) &&
                    e?.nativeEvent?.data !== null
                  )
                    return;
                  dispatch({
                    type: "onChangeMdAddOriginalDoc",
                    name: "phoneNumber",
                    value: e.target.value,
                  });
                }}
                placeholder={"Nhập số điện thoại"}
              />
            </div>
            {dialogAddOriginalDoc?.invalidPhoneNumber && (
              <div className="err">Số điện thoại không hợp lệ</div>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="textInput">
              <div className="label">
                Địa chỉ nhận {<span className="iconRed">*</span>}
              </div>
              <TextField
                fullWidth
                size="small"
                value={dialogAddOriginalDoc?.address || ""}
                onChange={(e) =>
                  dispatch({
                    type: "onChangeMdAddOriginalDoc",
                    name: "address",
                    value: e.target.value,
                  })
                }
                placeholder={"Nhập địa chỉ nhận"}
              />
            </div>
          </Grid>
        </Grid>
        <div className="footer">
          <Button
            className="button-action"
            onClick={() =>
              dispatch({
                type: "openConfirmMdAddOriginalDoc",
                value: true,
              })
            }
            disabled={isButtonDisabled(dialogAddOriginalDoc)}
          >
            {dialogAddOriginalDoc?.loading && (
              <CircularProgress
                color="inherit"
                size={"18px"}
                style={{ marginRight: 8 }}
              />
            )}
            Gửi thông tin
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const isButtonDisabled = (dialogAddOriginalDoc) => {
  const keys = ["fullname", "phoneNumber", "address"];
  const isMissingRequiredFields = keys.some(
    (key) => !dialogAddOriginalDoc[key]
  );
  const emptyElements = (dialogAddOriginalDoc?.elements || []).length === 0;
  return (
    isMissingRequiredFields || emptyElements || !!dialogAddOriginalDoc?.loading
  );
};

const makeStyle = makeStyles(() => ({
  dialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      borderRadius: "12px",
      width: "100%",
      margin: 0,
    },
    "& .header": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontWeight: 600,
      fontSize: 20,
    },

    "& .title": {
      color: "#1A427D",
      fontWeight: 500,
      fontSize: 16,
      marginBottom: 10,
    },
    "& .check-box": {
      display: " flex",
      alignItems: "center",
    },

    "& .info": {
      maxHeight: 400,
      overflow: "scroll",
    },

    "& .textInput": {
      fontSize: 14,
    },
    "& .label": {
      fontWeight: 500,
      marginBottom: "5px",
      color: "#333",
    },
    "& .iconRed": {
      color: "red",
      fontWeight: 500,
    },
    "& .err": { color: "red" },
    "& .footer": {
      margin: "30px 0px 10px",
      display: " flex",
      justifyContent: "flex-end",
    },

    "& .capitalize": {
      textTransform: "capitalize",
      "& .MuiOutlinedInput-input": {
        textTransform: "capitalize",
      },
    },

    "& .button-action": {
      textTransform: "none",
      background: "#3961A0",
      color: "white",
      borderRadius: "8px",
      padding: "8px 24px",
    },

    "& .MuiInputBase-root": { fontSize: 14 },
    "& .Mui-disabled": {
      opacity: 0.3,
    },
  },
}));
